import { PublicKey } from "@solana/web3.js";
import { deserializeUnchecked, serialize } from "borsh";
import { Community } from "./community";
import { Categories, HapiAccountType } from "./enums";
class CaseState {
    constructor(object) {
        Object.assign(this, object);
    }
}
CaseState.schema = new Map([
    [
        CaseState,
        {
            kind: "struct",
            fields: [
                ["account_type", "u8"],
                ["reporter_key", [32]],
                ["categories", "u32"],
                ["status", "u8"],
                ["name", "string"],
            ],
        },
    ],
]);
CaseState.size = 71;
export class Case {
    constructor(data) {
        /// HAPI account type
        this.accountType = HapiAccountType.Case;
        if (data) {
            Object.assign(this, data);
        }
    }
    static async getAddress(programId, communityAddress, caseId) {
        return PublicKey.findProgramAddress([Buffer.from("case"), communityAddress.toBuffer(), caseId.toBuffer()], programId);
    }
    static fromState(state) {
        return new Case({
            accountType: state.account_type,
            name: state.name,
            reporterKey: new PublicKey(state.reporter_key),
            status: state.status,
            categories: Categories.filter((category) => state.categories & category).sort(),
        });
    }
    static deserialize(buffer) {
        return Case.fromState(deserializeUnchecked(CaseState.schema, CaseState, buffer));
    }
    static async retrieve(programId, connection, communityName, caseId) {
        const [communityAddress] = await Community.getAddress(programId, communityName);
        const [caseAddress] = await Case.getAddress(programId, communityAddress, caseId);
        const account = await connection.getAccountInfo(caseAddress);
        if (!account) {
            throw new Error("Invalid case account provided");
        }
        return { data: Case.deserialize(account.data), account: communityAddress };
    }
    serialize() {
        const buf = Buffer.alloc(CaseState.size);
        buf.set(serialize(CaseState.schema, this.toState()));
        return buf;
    }
    toState() {
        return new CaseState({
            account_type: this.accountType,
            name: this.name,
            reporter_key: this.reporterKey.toBytes(),
            status: this.status,
            categories: this.categories.reduce((acc, category) => {
                return acc | category;
            }, 0),
        });
    }
}
//# sourceMappingURL=case.js.map